import { settingsContainer } from "../../di/container";
import {
  SettingsFormOperations,
  UseSettingsFormReturn,
  useSettingsForm,
} from "./useSettingsForm";

export type UseCompanySettingsReturn = UseSettingsFormReturn;

/**
 * Module scope on purpose: `useSettingsForm` memoises its loader on this
 * reference, so rebuilding the object on every render would refetch on every
 * render.
 */
const OPERATIONS: SettingsFormOperations = {
  load: (signal) => settingsContainer.getCompanySettings().execute(signal),
  save: (original, edited) =>
    settingsContainer.updateCompanySettings().execute(original, edited),
  subject: "company settings",
};

/**
 * Owns the Company Details form: loading, editing, saving.
 *
 * The mechanics moved to `useSettingsForm` when the GST panel needed the same
 * ones. This hook stays as the Company Details entry point, so every existing
 * caller and its return shape are unchanged.
 */
export const useCompanySettings = (): UseCompanySettingsReturn =>
  useSettingsForm(OPERATIONS);
